module.exports = __webpack_public_path__ + "static/media/Raz.f4e6e5fd.jpg";